/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  UncontrolledTooltip,
  Table,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as manageHighValueAction from "../../store/bWFuYWdlSGlnaFZhbHV/actions"
import { get, isEmpty } from "lodash"
import ButtonSpinner from "../../components/ButtonSpinner"
import imageNotFound from "../../assets/images/imageNotFound.png"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import { ToastContainer, toast } from "react-toastify"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import cellEditFactory from "react-bootstrap-table2-editor"
import SimpleReactValidator from "simple-react-validator"
import api from "helpers/Api"
//import attachmentDesktop from "../../assets/images/leads/attachmentDesktop.png"
// import { Link } from "react-router-dom/cjs/react-router-dom.min"

const ManageHighValueLead = (props) => {
  const title = "Manage High Value Lead"
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const rejectValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate1] = useState()
  const { dispatch, searchBtnStyle } = props
  const specificDispatch = useDispatch()
  //const firstDayOfMonth = moment().startOf("month").format("YYYY-MM-DD")

  const [downloadLoading, setDownloadLoading] = useState(false)
  //const [fullscreen, setFullscreen] = useState(false)
  useEffect(() => {
    dispatch(manageHighValueAction.loadRecordsMetaData())
    dispatch(
      manageHighValueAction.loadManageHighValueLead({
        page: 1,
        limit: 50,
      })
    )
    dispatch(manageHighValueAction.loadRecordsAttachmentDetailData())
  }, [])

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.manageHighValueLead
  )
  const {
    recordsMetaData = {},
    manageHighValueLead_details = [],
    attachmentRecord = [],
  } = permissionUpdate
  console.log(permissionUpdate)
  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  console.log(user, "user details from session")

  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
    responseLogin.setting &&
    responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  function addZeroBefore(number) {
    var numberString = "0" + number
    if (number < 10) {
      return numberString
    } else {
      return number
    }
  }
  //moment date
  var currentDate = moment().format("YYYY-MM-DD")
  var hourMoment = addZeroBefore(moment().format("HH"))
  var miniteMoment = addZeroBefore(moment().minutes())
  var dateTime = currentDate + "T" + hourMoment + ":" + miniteMoment

  console.log(dateTime, "date based output")
  // var currentTimeInputValue = currentHourMoment + ":" + currentMiniteMoment
  //Access section end

  const [btnLoader, setBtnLoader] = useState(false)
  const [followupData, setFollowupData] = useState({
    company: [],
    branch: [],
    managerName: "",
    fromDate: "",
    toDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [event, setEvent] = useState([])
  const [leadStatus, setLeadStatus] = useState([])
  const [managerName, setManagerName] = useState([])
  const [leadSubStatus, setLeadSubStatus] = useState([])

  //lead sub status options
  const leadSubStatusOptions = [
    { label: "Open", value: "Open" },
    { label: "Followup", value: "Followup" },
    { label: "Need time to think", value: "Need time to think" },
    { label: "Almost Confirm", value: "Almost Confirm" },
    { label: "Booked", value: "Booked" },
    { label: "Non Contactable", value: "Non Contactable" },
    {
      label: "Not Interested & Already Booked",
      value: "Not Interested & Already Booked",
    },
    {
      label: "Not Interested & Not Booked",
      value: "Not Interested & Not Booked",
    },
    { label: "Rejected", value: "Rejected" },
    { label: "yet to action", value: "Yet to action" },
  ]
  //column checkbox modal

  const [columnModal, setColumnModal] = useState(false)

  //dropdown options api
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )

  const employeeOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.employeeOptions
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const handleChange = async (e) => {
    setFollowupData({ ...followupData, [e.target.name]: e.target.value })
  }

  //followup modal
  const [currentFollowup, setCurrentFollowup] = useState({
    followupDate: "",
    time: "",
    budget: "",
    clientProfileRemarks: "",
    followupRemarks: "",
    overallStatus: "",
  })

  const handleFollowUpChange = (e) => {
    setCurrentFollowup({ ...currentFollowup, [e.target.name]: e.target.value })
  }
  const [followupMode, setFollowupMode] = useState([])
  const [clientProfile, setClientProfile] = useState([])
  const [followupStatus, setFollowupStatus] = useState([])

  const [reachOption, setReachOption] = useState({ option: "", checked: "" })

  const reachStatusOptions = [
    { id: 1, option: "Connected", label: "Connected" },
    { id: 2, option: "Not Connected", label: "Not Connected" },
  ]

  const handleReachStatusChange = (e, index) => {
    // console.log(reachStatusOptions[index].option, "valueradio")
    let value = reachStatusOptions[0].option
    setReachOption({ option: value, checked: index })
  }

  const [vipOption, setVipOption] = useState({ option: "", checked: "" })

  const vipOptions = [
    { id: 1, option: "VIP", label: "VIP" },
    { id: 2, option: "VVIP", label: "VVIP" },
  ]

  const handleVipStatusChange = (e, index) => {
    // console.log(reachStatusOptions[index].option, "valueradio")
    let value = vipOptions[0].option
    setVipOption({ option: value, checked: index })
  }

  const [futureFollowup, setFutureFollowup] = useState({
    ffFollowupDate: "",
    ffVisitDateTime: "",
    ffSession: "",
    ffStrategyRemark: "",
  })
  console.log(futureFollowup, "futureFollowup")

  const handleFutureFollowUpChange = (e) => {
    const { name, value } = e.target

    if (name === "ffFollowupDate") {
      const sessionHour = moment(value).format("H")
      const hour = parseInt(sessionHour)

      let session = ""
      if (hour >= 5 && hour < 12) {
        session = "Morning"
      } else if (hour >= 12 && hour < 17) {
        session = "Afternoon"
      } else if (hour >= 17 && hour < 21) {
        session = "Evening"
      } else {
        session = "Night"
      }

      setFutureFollowup({
        ...futureFollowup,
        ffSession: session,
        [name]: value,
      })
    } else {
      setFutureFollowup({ ...futureFollowup, [name]: value })
    }
  }

  const [clientVisit, setClientVisit] = useState([])
  const [ffFollowupMode, setFfFollowupMode] = useState([])
  const [ffFollowupStrategy, setFfFollowupStrategy] = useState([])
  const [ffSalesUrge, setFfSalesUrge] = useState([])
  const clientVisitOptions = [
    { label: "Office Visit", value: "1" },
    { label: "Client Visit", value: "2" },
  ]
  //followup modal
  const [followupModal, setFollowupModal] = useState(false)
  const [renderPage, setRenderPage] = useState(false)
  const [uploadAttachment, setUploadAttachment] = useState([])

  const [mobileAttachmentForm, setMobileAttachmentForm] = useState(false)
  const [mobileAttachmentSelected, setMobileAttachmentSelected] = useState([])
  const [attachmentValidation, setAttachmentValidation] = useState(false)

  //ref for attachment
  const inputDesktopAttachmentFile = useRef(null)
  const [uploadFileName, setUploadFileName] = useState("")
  //const [uploadFileLength, setUploadFileLength] = useState("")

  const fileChange = async (e, renderPage) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      await setMobileAttachmentSelected([])
      setUploadAttachment(e.target.files)
      var file = e.target.files
      setUploadFileName(file[0].name)
      // setUploadFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadAttachment(teamUploadValue)
            await setRenderPage(!renderPage)
          }
        })

        await setAttachmentValidation(false)
        await setMobileAttachmentForm(false)
      }
    }
  }

  // handle click for mobile or desktop
  const handleClickAttachment = async (value) => {
    if (value == "desktop") {
      await setUploadAttachment([])
      if (inputDesktopAttachmentFile.current) {
        inputDesktopAttachmentFile.current.click()
      }
    }
    if (value == "mobile") {
      setMobileAttachmentForm(true)
      setMobileAttachmentSelected([])
    }
  }
  const handleCloseAttachment = () => {
    setMobileAttachmentForm(false)
    setMobileAttachmentSelected([])
  }
  const handleSubmitAttachment = async () => {
    setMobileAttachmentForm(false)
  }
  //mobile attachment modal checkbox onchange functionality
  const handleChangeAttachmentCheckbox = async (
    e,
    valueId,
    valueAttachment
  ) => {
    setUploadAttachment([])
    var selectedValue = mobileAttachmentSelected
    if (e.target.checked) {
      selectedValue.push({ id: valueId, attachment: valueAttachment })
    } else {
      const index = selectedValue.indexOf(valueId)
      if (index > -1) {
        selectedValue.splice(index, 1)
      }
    }
    setMobileAttachmentSelected(selectedValue)
    setAttachmentValidation(false)
    setRenderPage(!renderPage)
  }
  //Attatchment Data
  const attachmentRecordUpdated = !isEmpty(attachmentRecord)
    ? attachmentRecord.map((attachment, index) => {
        var attachmentFile = attachment.attachment
        var attachmentFileExtenstion = attachmentFile.split(".")
        var attachmentFileExtenstionType =
          attachmentFileExtenstion[attachmentFileExtenstion.length - 1]
        var attachmentType = "file"

        if (attachmentFileExtenstionType) {
          if (
            attachmentFileExtenstionType == "jpg" ||
            attachmentFileExtenstionType == "png" ||
            attachmentFileExtenstionType == "jpeg"
          ) {
            attachmentType = "image"
          } else if (
            attachmentFileExtenstionType == "mp3" ||
            attachmentFileExtenstionType == "wav" ||
            attachmentFileExtenstionType == "mp4" ||
            attachmentFileExtenstionType == "m4a" ||
            attachmentFileExtenstionType == "m4b" ||
            attachmentFileExtenstionType == "msv" ||
            attachmentFileExtenstionType == "mmf" ||
            attachmentFileExtenstionType == "m4p" ||
            attachmentFileExtenstionType == "wma" ||
            attachmentFileExtenstionType == "aac" ||
            attachmentFileExtenstionType == "ac3" ||
            attachmentFileExtenstionType == "aiff" ||
            attachmentFileExtenstionType == "flac" ||
            attachmentFileExtenstionType == "ogg" ||
            attachmentFileExtenstionType == "opus" ||
            attachmentFileExtenstionType == "ts" ||
            attachmentFileExtenstionType == "wav" ||
            attachmentFileExtenstionType == "amr"
          ) {
            attachmentType = "audio"
          }
        }

        return {
          key: index,
          id: get(attachment, "_id", ""),
          customerDetails: get(attachment, "customerDetails", ""),
          description: get(attachment, "description", ""),
          pickDateTime: get(attachment, "pickDateTime", ""),
          attachment: get(attachment, "attachment", ""),
          attachmentType: attachmentType,
        }
      })
    : []

  useEffect(() => {
    if (followupModal) {
      var currentDateMoment = moment().format("YYYY-MM-DD")
      var currentHour = moment().format("H")
      var currentMinute = moment().format("mm")
      var currentHourMinute = moment().format("hh:mm")
      var currentHourMoment = addZeroBefore(moment().format("HH"))
      var currentMiniteMoment = addZeroBefore(moment().minutes())
      var currentDateTime =
        currentDateMoment + "T" + currentHourMoment + ":" + currentMiniteMoment

      console.log(currentDateTime, "date based output")

      const currentSessionHour = currentHour + "." + currentMinute
      console.log(currentSessionHour, "currentSessionHour")

      let sessionHour = ""
      if (currentSessionHour >= 5 && currentSessionHour < 12) {
        sessionHour = "Morning"
      } else if (currentSessionHour >= 12 && currentSessionHour < 17) {
        sessionHour = "Afternoon"
      } else if (currentSessionHour >= 17 && currentSessionHour < 21) {
        sessionHour = "Evening"
      } else {
        sessionHour = "Night"
      }
      setFutureFollowup({
        ffFollowupDate: currentDateTime,
        ffSession: sessionHour,
        ffVisitDateTime: currentDateTime,
      })
      console.log(currentHourMinute, "sessionHour")
      setCurrentFollowup({
        ...currentFollowup,
        followupDate: currentDateMoment,
        time: currentHourMinute,
      })
    }
  }, [followupModal])

  //handle clear followup modal
  const handleClearFollowup = () => {
    setCurrentFollowup({
      ...currentFollowup,
      // followupDate: "",
      // time: "",

      clientProfileRemarks: "",
      followupRemarks: "",
      overallStatus: "",
    })
    setFollowupMode([])
    setClientProfile([])
    setFollowupStatus([])
    setVipOption({ option: "", checked: "" })
    setReachOption({ option: "", checked: "" })
    setFutureFollowup({
      ffStrategyRemark: "",
    })
    setClientVisit([])
    setFfFollowupMode([])
    setFfFollowupStrategy([])

    setUploadAttachment([])
  }
  // console.log(currentTime)

  //const currentdateTime = moment().format("YYYY-MM-DD LT")
  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        page: 1,
        limit: 50,
      }

  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? companies.value : ""
    var searchBranch = branches && branches ? branches.value : ""
    var searchEvent = event && event ? event.value : ""
    var searchLeadStatus = leadStatus && leadStatus ? leadStatus.value : ""
    var searchManagerName = managerName && managerName ? managerName.value : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
    var searchLeadSubStatus = leadSubStatus ? leadSubStatus.value : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadStatus) {
      searchvalue.leadStatus = searchLeadStatus
    }
    if (searchLeadSubStatus) {
      searchvalue.leadSubStatus = searchLeadSubStatus
    }
    if (searchManagerName) {
      searchvalue.assignEmp = searchManagerName
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }
    setSearchValueList(searchvalue)
    setPageLoad(!pageLoad)
    console.log("searchCompany", searchvalue)
    specificDispatch(manageHighValueAction.loadManageHighValueLead(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const [resetManager, setResetManager] = useState(false)
  //const today = moment().format("YYYY-MM-DD")
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setLeadStatus([])
    setEvent([])
    setManagerName(null)
    setSalesUrge([])
    setLeadSubStatus([])
    setFollowupData({
      fromDate: "",
      toDate: "",
    })
    setSearchValueList({})

    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      manageHighValueAction.loadManageHighValueLead({
        page: 1,
        limit: 50,
        // fromDate: today,
        // toDate: today,
      })
    )
  }
  //edit followupModal
  const editFollowUpModal = (data) => {
    setFfSalesUrge({ label: data.salesUrge })
    setCurrentFollowup({ ...currentFollowup, budget: data.budget })
  }
  // reject modal
  const [rejectData, setRejectData] = useState({
    remarks: "",
  })
  const handleRejectChange = (e) => {
    setRejectData({ ...rejectData, [e.target.name]: e.target.value })
  }
  const [rejectAttachment, setRejectAttachment] = useState([])
  const rejectFileChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setRejectAttachment(e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = rejectAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setRejectAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const [rejectStatus, setRejectStatus] = useState([])
  const handleClearReject = () => {
    setRejectData({ ...rejectData, remarks: "" })
    setRejectAttachment([])
    setRejectStatus([])
  }
  const [rejectModal, setRejectModal] = useState(false)
  const [leadId, setLeadId] = useState("")
  const [rejectLeadId, setRejectLeadId] = useState("")
  const [updateSubstatusData, setUpdateSubStatusData] = useState("")
  let slNo = 0
  const manageHighValueLeadTable = !isEmpty(manageHighValueLead_details)
    ? manageHighValueLead_details.data.map((data, index) => {
        slNo = slNo + 1

        var leadDate = !isEmpty(data.leadDate)
          ? moment(data.leadDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []

        var eventDate =
          !isEmpty(data) &&
          !isEmpty(data.eventDetails) &&
          data.eventDetails.length > 0
            ? moment(data.eventDetails[0].eventDate).format(dateFormate)
            : ""
        const colorCode =
          !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0 &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.processStatus
          ).colorCode
        return {
          _id: data.leadId,
          leadId: data.leadId,
          sNo: slNo,
          leadNo: (
            <Link
              to={{
                pathname: `/client-details/${data.leadId}`,
                state: { row: data, mode: "SALES" },
              }}
            >
              {data.leadNo}
            </Link>
          ),
          companyId: data.companyId ? data.companyId : "--",
          company: data.companyName ? data.companyName : "--",
          branchId: data.branchId,
          branch: data.branchName ? data.branchName : "--",
          salesUrge: data.salesUrge ? data.salesUrge : "--",
          managerName: data.assignedBy ? data.assignedBy : "--",
          budget: data.budget ? data.budget : "--",
          leadSubStatus: data.leadSubStatus,
          leadStatus: data.processStatusName ? (
            <div>
              <button
                style={{
                  background: colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {data.processStatusName}
              </button>
            </div>
          ) : (
            "--"
          ),
          processStatus: data.processStatus,
          eventDate: eventDate ? eventDate : "--",
          followUpDate: data.followUpDate
            ? moment(data.followUpDate).format(dateFormate)
            : "--",
          remarks: data.followUpRemarks ? data.followUpRemarks : "--",
          leadDate: data.leadDate ? leadDate : "--",
          followup: (
            <Button
              className="btn btn-info"
              onClick={() => {
                setFollowupModal(true)
                //  setFullscreen(true)
                setLeadId(data.leadId)
                handleClearFollowup()
                editFollowUpModal(data)
              }}
              disabled
            >
              Followup
            </Button>
          ),
          clientCode:data.clientCode?data.clientCode:"--",
          clientName:data.clientName?data.clientName:"--",
          followUpRemarks:data.overAllStatus
          ?data.overAllStatus:"--",
          key: index,
        }
      })
    : []
  //pagination table data columns
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      hidden: false,
      editable: false,
      csvExport: false,
      style: {
        textTransform: "uppercase",
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },

    {
      dataField: "company",
      text: "Company",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "clientCode",
      text: " Client Code",
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
      style: {
        textTransform: "uppercase",
      },
    },
    {
      dataField: "managerName",
      text: "Manager Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "budget",
      text: "Budget",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "leadSubStatus",
      text: "Lead Sub Status",
      hidden: false,
      editable: false,
      // editor: {
      //   type: Type.SELECT,
      //   options: leadSubStatusOptions,
      // },
      // formatter: (cellContent, row) => {
      //   return (
      //     <>
      //       <Row>
      //         <Col md="8" lg="8" sm="8">
      //           {row.leadSubStatus}
      //         </Col>
      //         <Col md="2" lg="2" sm="2">
      //           <button
      //             style={{
      //               background: "#17b77d",
      //               border: "none",
      //               cursor: "pointer",
      //               color: "white",
      //               padding: "4px 8px",
      //               borderRadius: "3px",
      //             }}
      //           >
      //             <i
      //               className="fas fa-edit icon-btn"
      //               style={{ fontSize: "10px" }}
      //             ></i>
      //           </button>
      //         </Col>
      //       </Row>
      //     </>
      //   )
      // },
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "138px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "followUpDate",
      text: "Follow Up Date",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "remarks",
      text: "Remarks",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "leadDate",
      text: "Lead Action Date & Time",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "followUpRemarks",
      text: "Follow Up Remarks",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "followup",
      text: "Followup",
      editable: false,
      hidden: false,
      // formatter: (cellContent, row) => {
      //   // console.log(row)
      //   return (
      //     <Button
      //       className="btn btn-info"
      //       onClick={() => {
      //         setFollowupModal(true)
      //       //  setFullscreen(true)
      //         setLeadId(row.leadId)
      //         handleClearFollowup()
      //         editFollowUpModal(row)
      //       }}
      //     >
      //       Followup
      //     </Button>
      //   )
      // },
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]
  const [rendersPage, setRendersPage] = useState(false)
  const handleMessage = () => {
    setFollowupModal(false)
    setRendersPage(!rendersPage)
    simpleValidator.current.hideMessages()
  }
  const [columns, setColumns] = useState(initialColumns)
  const beforeSaveCell = (oldValue, newValue, row, column) => {
    // setCellEditing(true)
    console.log(row, "myrow")
    const dataField = !isEmpty(column) ? column.dataField : []

    if (dataField === "leadSubStatus") {
      const subStatusValues = {
        leadId: row.leadId,
        leadSubStatus: newValue,
      }
      console.log(subStatusValues, "substatus")
      if (newValue !== "Followup" && newValue !== "Rejected") {
        console.log(subStatusValues, "checking")
        dispatch(manageHighValueAction.updateSubStatus(subStatusValues))

        setTimeout(() => {
          dispatch(manageHighValueAction.loadManageHighValueLead(searchValue))
          toast.success("Lead Sub Status Updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
        }, 1000)
      }
      if (newValue === "Rejected") {
        setRejectModal(true)
        setUpdateSubStatusData(subStatusValues)
        setRejectLeadId(row.leadId)
        handleClearReject()
      }
    }
  }
  //handle error message in  reject modal
  const [renderingPage, setRenderingPage] = useState(false)
  const handleRejectMessage = () => {
    setRejectModal(false)
    setRenderingPage(!renderingPage)
    rejectValidator.current.hideMessages()
  }
  // reject modal submit
  const rejectSubmit = () => {
    if (rejectValidator.current.allValid()) {
      const rejectValues = {
        _id: rejectLeadId,
        rejectReasonId: rejectStatus.value,
        rejectedRemarks: rejectData.remarks,
        rejectAttachment: rejectAttachment[0],
      }
      console.log(rejectValues, "rejectvalues")
      console.log(updateSubstatusData, "rejectvalues")
      dispatch(manageHighValueAction.updateReject(rejectValues))
      dispatch(manageHighValueAction.updateSubStatus(updateSubstatusData))
      setRejectModal(false)
      setTimeout(() => {
        dispatch(manageHighValueAction.loadManageHighValueLead(searchValue))
        toast.success("Lead Sub Status Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
    } else {
      rejectValidator.current.showMessages()
      forceUpdate1(1)
      setRenderingPage(!renderingPage)
    }
  }
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  console.log(oddColumnData, "oddcolumns")
  console.log(evenColumnData, "evencolumns")

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const followupSubmit = () => {
    var AttachmentValue = []
    if (uploadAttachment && uploadAttachment.length > 0) {
      uploadAttachment.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    //submit followup
    if (
      simpleValidator.current.allValid() &&
      AttachmentValue &&
      AttachmentValue.length > 0
    ) {
      const followupValues = {
        leadId: leadId,
        currentFollowup: {
          followupDate: currentFollowup.followupDate,
          followupTime: currentFollowup.time,
          mode: followupMode.value,
          followupStatus: followupStatus.value,
          budget: currentFollowup.budget,
          clientProfile: clientProfile.value,
          clientProfileRemarks: currentFollowup.clientProfileRemarks,
          clientProfileStatus: vipOption.option,
          clientReachedStatus: reachOption.option,
          remarks: currentFollowup.followupRemarks,
          recordAttachment: AttachmentValue,
          overallStatus: currentFollowup.overallStatus,
        },
        futureFollowup: {
          followupDate: futureFollowup.ffFollowupDate,
          mode: ffFollowupMode.value,
          clientVisit: clientVisit.value,
          visitDateTime: dateTime,
          session: futureFollowup.ffSession,
          followupStrategyId: ffFollowupStrategy.value,
          strategyRemark: futureFollowup.ffStrategyRemark,
          futureFollowupSalesUrge: ffSalesUrge.value,
        },
      }

      console.log(followupValues, "followupValues")
      dispatch(manageHighValueAction.addFollowUp(followupValues))
      setFollowupModal(false)
      // attchment upload

      if (mobileAttachmentSelected && mobileAttachmentSelected.length > 0) {
        const mobileAttachmentSelectedIdData = !isEmpty(
          mobileAttachmentSelected
        )
          ? mobileAttachmentSelected.map((data) => {
              return data.id
            })
          : []
        if (
          mobileAttachmentSelectedIdData &&
          mobileAttachmentSelectedIdData.length > 0
        ) {
          var objectValue = {
            callUploadId: mobileAttachmentSelectedIdData,
            status: 2,
          }
          dispatch(
            manageHighValueAction.uploadFollowupAttachmentRecordData(
              objectValue
            )
          )
        }
      }
      setUploadAttachment([])
      setMobileAttachmentSelected([])

      setTimeout(() => {
        dispatch(manageHighValueAction.loadManageHighValueLead(searchValue))

        toast.success("Follow Up Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setFollowupModal(true)
      setRendersPage(!rendersPage)
    }
  }
  const [loading, setLoading] = useState(false)

  //Search filter
  const [searchFilter, setSearchFilter] = useState(false)
  const handleClick = (e) => {
    // props.onSearch(input.value)
    // console.log(input.value, "inputs")
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      manageHighValueAction.loadManageHighValueLead({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
    // console.log(input.value, "input")
  }

  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  // const [downloadData, setDownloadData] = useState("")

  // console.log(downloadData, "downloadData")

  const exportToCsv = () => {
    // if (
    //   !isEmpty(companies) ||
    //   !isEmpty(branches) ||
    //   !isEmpty(event) ||
    //   !isEmpty(leadStatus) ||
    //   !isEmpty(leadSubStatus) ||
    //   !isEmpty(managerName) ||
    //   !isEmpty(salesUrge) ||
    //   !isEmpty(followupData.fromDate) ||
    //   !isEmpty(followupData.toDate)
    // ) {
    var searchCompany = companies && companies ? companies.value : ""
    var searchBranch = branches && branches ? branches.value : ""
    var searchEvent = event && event ? event.value : ""
    var searchLeadStatus = leadStatus && leadStatus ? leadStatus.value : ""
    var searchLeadSubStatus =
      leadSubStatus && leadSubStatus ? leadSubStatus.value : ""
    var searchManagerName = managerName && managerName ? managerName.value : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
    var searchvalue = {}
    // searchvalue.page = pageChange ? pageCount : 1
    // searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadStatus) {
      searchvalue.leadStatus = searchLeadStatus
    }
    if (searchLeadSubStatus) {
      searchvalue.leadSubStatus = searchLeadSubStatus
    }
    if (searchManagerName) {
      searchvalue.assignEmp = searchManagerName
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }

    setPageLoad(!pageLoad)
    console.log("searchCompany", searchvalue)
    setDownloadLoading(true)
    api
      .post(`/get_high_value_lead_xcel_export`, searchvalue)
      .then((response) => {
        const manageHighValueLeadExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              // serialNo = serialNo + 1
              var leadDate = !isEmpty(data.leadDate)
                ? moment(data.leadDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                : []
              var getEventDate = !isEmpty(data.eventDetails)
                ? data.eventDetails
                    .map((m) => moment(m.eventDate).format(dateFormate))
                    .filter(Boolean)
                : ""
              var eventDate =
                getEventDate.length > 0 ? getEventDate.join(" ,") : ""

              const eventDateDetails = !isEmpty(eventDate)
                ? JSON.stringify(eventDate).replace(/","/g, "\n")
                : "--"
              const followupRemarks = !isEmpty(data.overAllStatus)
              ? data.overAllStatus.replace(/[\r\n,.]/gm, "")
              : "--"
              return {
                _id: data.leadId,
                sNo: index + 1,
                leadNo: data.leadNo ? data.leadNo : "--",
                companyId: data.companyId ? data.companyId : "--",
                companyName: data.companyName ? data.companyName : "--",
                branchId: data.branchId,
                branchName: data.branchName ? data.branchName : "--",
                salesUrge: data.salesUrge ? data.salesUrge : "--",
                managerName: data.assignedBy ? data.assignedBy : "--",
                budget: data.budget ? data.budget : "--",
                leadSubStatus: data.leadSubStatus ? data.leadSubStatus : "--",
                leadStatus: data.processStatusName
                  ? data.processStatusName
                  : "--",
                processStatus: data.processStatus,
                eventDate: eventDateDetails,
                followUpDate: data.followUpDate
                  ? moment(data.followUpDate).format(dateFormate)
                  : "--",
                remarks: followupRemarks,
                leadDate: data.leadDate ? leadDate : "--",
                clientCode:data.clientCode?data.clientCode:"--",
                clientName:data.clientName?data.clientName:"--",
                followUpRemarks:followupRemarks,
                key: index,
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,Company Name, Branch Name,Client Code,Client Name,Sales Urge,Manager Name, Budget,Lead Sub Status,Lead Status,Event Date,Followup Date,Remarks, FollowUp Remarks,Lead Action Date and Time",
          ]

          let usersCsv =
            !isEmpty(manageHighValueLeadExportDataTable) &&
            manageHighValueLeadExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                companyName,
                branchName,
                clientCode,
                clientName,
                salesUrge,
                managerName,
                budget,
                leadSubStatus,
                leadStatus,
                eventDate,
                followUpDate,
                remarks,
                followUpRemarks,
                leadDate,
              } = user
              acc.push([
                sNo,
                leadNo,
                companyName,
                branchName,
                clientCode,
                clientName,
                salesUrge,
                managerName,
                budget,
                leadSubStatus,
                leadStatus,
                eventDate,
                followUpDate,
                remarks,
                followUpRemarks,
                leadDate,
              ])

              console.log("test", acc)
              return acc
            }, [])

          const userList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : ""
          console.log(usersCsv, "usersCsv")
          downloadFile({
            data: [...headerData, ...userList].join("\n"),
            fileName: "manageHighValueLead.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
         setDownloadLoading(false)
      })
    //   // specificDispatch(
    //   //   manageFollowupAction.loadManageFollowupExportList(searchvalue)
    //   // )
    // }
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        {/* <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBtnStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "} */}
                      </Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            beforeSaveCell,
                            autoSelectText: true,
                            blurToSave: true,
                          })}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: manageHighValueLead_details.length,
    data:
      !isEmpty(manageHighValueLead_details) &&
      manageHighValueLead_details.length > 0
        ? manageHighValueLead_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(manageHighValueLead_details) &&
      manageHighValueLead_details.length > 0
        ? manageHighValueLead_details
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate) ||
      !isEmpty(event) ||
      !isEmpty(leadStatus) ||
      !isEmpty(leadSubStatus) ||
      !isEmpty(managerName) ||
      !isEmpty(salesUrge)
    ) {
      var searchCompany = companies && companies ? companies.value : ""
      var searchBranch = branches && branches ? branches.value : ""
      var searchEvent = event && event ? event.value : ""
      var searchLeadStatus = leadStatus && leadStatus ? leadStatus.value : ""
      var searchLeadSubStatus =
        leadSubStatus && leadSubStatus ? leadSubStatus.value : ""
      var searchManagerName =
        managerName && managerName ? managerName.value : ""
      var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
      var searchFromDate =
        followupData && followupData.fromDate
          ? moment(followupData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        followupData && followupData.toDate
          ? moment(followupData.toDate).format("YYYY-MM-DD")
          : ""

      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEvent) {
        searchvalue.eventId = searchEvent
      }
      if (searchLeadStatus) {
        searchvalue.leadStatus = searchLeadStatus
      }
      if (searchLeadSubStatus) {
        searchvalue.leadSubStatus = searchLeadSubStatus
      }
      if (searchManagerName) {
        searchvalue.assignEmp = searchManagerName
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      if (searchSalesUrge) {
        searchvalue.salesUrge = searchSalesUrge
      }

      setPageLoad(!pageLoad)
      console.log("searchCompany", searchvalue)
      setLoading(true)
      specificDispatch(
        manageHighValueAction.loadManageHighValueLead(searchvalue)
      )
    } else {
      dispatch(
        manageHighValueAction.loadManageHighValueLead({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }
    // setState(() => ({
    //   page,
    //   data: result.slice(currentIndex, currentIndex + sizePerPage),
    //   totalSize: result.length,
    //   sizePerPage
    // }))
    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Sales Urge"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="salesUgre"
                          value={salesUrge}
                          onChange={(e) => setSalesUrge(e)}
                          options={[
                            { label: "Hot", value: "hot" },
                            { label: "Warm", value: "warm" },
                            { label: "Cold", value: "cold" },
                          ]}
                          placeholder="Select Sales Urge"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Manager Name"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="managerName"
                          key={resetManager}
                          items={employeeOptions}
                          value={managerName ? managerName : ""}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setManagerName(e)}
                          onChange={(e) => setManagerName(e.target.value)}
                          placeholder="Enter Manager Name"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          name="event"
                          value={event}
                          onChange={(e) => setEvent(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select Event"
                          classNamePrefix="select2-selection"
                        />
                      </Col> */}

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Status"}
                          </Label>
                        </div>
                        <Select
                          name="leadStatus"
                          value={leadStatus}
                          onChange={(e) => setLeadStatus(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.processStatusOptions
                              : []
                          }
                          placeholder="Select Lead Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Sub Status"}
                          </Label>
                        </div>
                        <Select
                          name="leadSubStatus"
                          value={leadSubStatus}
                          onChange={(e) => setLeadSubStatus(e)}
                          options={leadSubStatusOptions}
                          placeholder="Select Lead Sub Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          max={followupData.toDate}
                          value={followupData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          min={followupData.fromDate}
                          value={followupData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={manageHighValueLeadTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(manageHighValueLead_details)
                        ? manageHighValueLead_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {followupModal && (
                    <Modal size="xl" show={followupModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Followup
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="quote-head-content">
                          <Col md="6" lg="6" sm="12">
                            <div className="d-flex">
                              <p className="quote-head">
                                Current Followup
                                <span className="quote-info">
                                  <i
                                    style={{ color: "grey" }}
                                    id="quoteInfo1"
                                    aria-hidden="true"
                                    className="fa fa-info-circle ms-1"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="right"
                                    target="quoteInfo1"
                                  >
                                    Current Followup
                                  </UncontrolledTooltip>
                                </span>
                              </p>
                            </div>
                          </Col>
                        </Row>
                        <Row className="d-flex flex-row">
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Follow-Up-Date"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="date"
                              placeholder="Select Date"
                              name="followUpDate"
                              value={currentFollowup.followupDate}
                              onChange={(e) => handleFollowUpChange(e)}
                              disabled
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className="form-label" htmlFor={"Time"}>
                                {"Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Time"
                              name="time"
                              value={currentFollowup.time}
                              onChange={(e) => handleFollowUpChange(e)}
                              disabled
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Follow-Up-Mode"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="followupMode"
                              value={followupMode}
                              onChange={(e) => setFollowupMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Follow Up Mode"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followupMode",
                                followupMode,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className="form-label" htmlFor={"Budget"}>
                                {"Budget"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Budget"
                              name="budget"
                              value={currentFollowup.budget}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "budget",
                                currentFollowup.budget,
                                "required|numeric"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Client Profile"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="clientProfile"
                              value={clientProfile}
                              onChange={(e) => setClientProfile(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.clientProfileOptions
                                  : []
                              }
                              placeholder="Select Client Profile"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "clientProfile",
                                clientProfile,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Client Profile Remarks"}
                              >
                                {"Client Profile Remarks"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Client Profile Remarks"
                              name="clientProfileRemarks"
                              value={currentFollowup.clientProfileRemarks}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "clientProfileRemarks",
                                currentFollowup.clientProfileRemarks,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between vip-checkbox-div">
                              <Label className="event-label"></Label>
                            </div>
                            <div className="d-flex flex-row">
                              {vipOptions.map((item, index) => {
                                return (
                                  <>
                                    <div className="form-check form-check-inline">
                                      <Input
                                        type="checkbox"
                                        key={item.id}
                                        name="vip"
                                        value={vipOption.option}
                                        checked={vipOption.checked === index}
                                        onChange={(e) =>
                                          handleVipStatusChange(e, index)
                                        }
                                      />

                                      <Label>{item.label}</Label>
                                    </div>
                                  </>
                                )
                              })}
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Client Profile Status",
                                vipOption.option,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Reach Status"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row">
                              {reachStatusOptions.map((item, index) => {
                                return (
                                  <>
                                    <div className="form-check form-check-inline">
                                      <Input
                                        type="radio"
                                        key={item.id}
                                        name="Reach Status"
                                        value={reachOption.option}
                                        checked={reachOption.checked === index}
                                        onChange={(e) =>
                                          handleReachStatusChange(e, index)
                                        }
                                      />

                                      <Label>{item.label}</Label>
                                    </div>
                                  </>
                                )
                              })}
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Reach Status",
                                reachOption.option,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Followup Remarks"}
                              >
                                {"Followup Remarks"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Followup Remarks"
                              name="followupRemarks"
                              value={currentFollowup.followupRemarks}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followupRemarks",
                                currentFollowup.followupRemarks,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}{" "}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <input
                                  type="file"
                                  name="uploadAttachment"
                                  accept="application/pdf, audio/mp3 , image/png,image/jpeg"
                                  id="uploadAttachment"
                                  multiple
                                  onChange={(e) => fileChange(e, renderPage)}
                                  ref={inputDesktopAttachmentFile}
                                  style={{ display: "none" }}
                                />

                                <Button
                                  className=" btn btn-warning  position-relative fs-5"
                                  onClick={() =>
                                    handleClickAttachment("desktop")
                                  }
                                >
                                  <i className="fas fa-laptop"></i>

                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {uploadAttachment.length}
                                  </span>
                                </Button>
                              </div>
                              <div style={{ marginLeft: "20px" }}>
                                <Button
                                  className=" btn btn-info  position-relative fs-5"
                                  onClick={() =>
                                    handleClickAttachment("mobile")
                                  }
                                >
                                  <i className="fas fa-mobile-alt fs-3"></i>
                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {mobileAttachmentSelected.length}
                                  </span>
                                </Button>
                              </div>
                            </div>
                            {uploadAttachment.length > 0 ? (
                              <div className="text-decoration-underline text-danger">
                                {uploadFileName ? uploadFileName : ""}
                              </div>
                            ) : (
                              ""
                            )}
                            {attachmentValidation == true &&
                            (uploadAttachment.length == 0 ||
                              mobileAttachmentSelected.length == 0) ? (
                              <div className="srv-validation-message">
                                The Attachment field is required.
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Follow-Up-Status"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="followupStatus"
                              value={followupStatus}
                              onChange={(e) => setFollowupStatus(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpStatusOptions
                                  : []
                              }
                              placeholder="Select Follow Up Status"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followupStatus",
                                followupStatus,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Overall Status"}
                              >
                                {"Overall Status"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Overall Status"
                              name="overallStatus"
                              value={currentFollowup.overallStatus}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "overallStatus",
                                currentFollowup.overallStatus,
                                "required"
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Col
                          md="12"
                          lg="12"
                          sm="12"
                          className="quote-head-content"
                        >
                          <p className="quote-head">
                            Future Followup
                            <span className="quote-info">
                              <i
                                style={{ color: "grey" }}
                                id="quoteInfo1"
                                aria-hidden="true"
                                className="fa fa-info-circle ms-1"
                              ></i>
                              <UncontrolledTooltip
                                placement="right"
                                target="quoteInfo1"
                              >
                                Future Followup
                              </UncontrolledTooltip>
                            </span>
                          </p>
                        </Col>
                        <Row className="d-flex flex-row">
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Follow-Up-Date"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              name="ffFollowupDate"
                              value={futureFollowup.ffFollowupDate}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                              placeholder="Select Follow-Up Date"
                            />

                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followupDate",
                                futureFollowup.ffFollowupDate,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Follow-Up-Mode"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="ffFollowupMode"
                              value={ffFollowupMode}
                              onChange={(e) => setFfFollowupMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Follow Up Mode"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followupMode",
                                ffFollowupMode,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Client Visit"}
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="clientVisit"
                              value={clientVisit}
                              onChange={(e) => setClientVisit(e)}
                              options={clientVisitOptions}
                              placeholder="Select Client Visit"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className="event-label">
                                {" Visit Date & Time "}
                                <span className="event-required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              name="ffVisitDateTime"
                              onChange={(e) => handleFutureFollowUpChange(e)}
                              placeholder="Select Date"
                              value={futureFollowup.ffVisitDateTime}
                              disabled
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className="form-label" htmlFor={"Session"}>
                                {"Session"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Session"
                              name="ffSession"
                              value={futureFollowup.ffSession}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                              disabled
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "session",
                                futureFollowup.ffSession,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Follow-Up Strategy"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="ffFollowupStrategy"
                              value={ffFollowupStrategy}
                              onChange={(e) => setFfFollowupStrategy(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpStrategyOptions
                                  : []
                              }
                              placeholder="Select Follow Up Strategy"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followupStrategy",
                                ffFollowupStrategy,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Strategy Remark"}
                              >
                                {"Strategy Remark"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Strategy Remark"
                              name="ffStrategyRemark"
                              value={futureFollowup.ffStrategyRemark}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "strategyRemark",
                                futureFollowup.ffStrategyRemark,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Sales Urge"}{" "}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="ffSalesUgre"
                              value={ffSalesUrge}
                              onChange={(e) => setFfSalesUrge(e)}
                              options={[
                                { label: "Hot", value: "hot" },
                                { label: "Warm", value: "warm" },
                                { label: "Cold", value: "cold" },
                              ]}
                              placeholder="Select Sales Urge"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "salesUrge",
                                ffSalesUrge,
                                "required"
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          className="btn btn-danger"
                          onClick={() => handleMessage()}
                        >
                          Cancel
                        </Button>
                        <Button
                          className="btn btn-success"
                          onClick={() => {
                            setFollowupModal(false)
                            followupSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {rejectModal && (
                    <Modal
                      show={rejectModal}
                      size="md"
                      style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                    >
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Rejected</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            <Label className={"form-label"}>
                              {"Reject Status"}{" "}
                              <span className="required">*</span>
                            </Label>
                          </div>
                          <Select
                            type="text"
                            name="rejectStatus"
                            value={rejectStatus}
                            onChange={(e) => setRejectStatus(e)}
                            options={
                              recordsMetaData
                                ? recordsMetaData.rejectOptions
                                : []
                            }
                            placeholder="Select Reject Status"
                            classNamePrefix="select2-selection"
                          />
                          <div style={{ textTransform: "capitalize" }}>
                            {rejectValidator.current.message(
                              "Reject Status",
                              rejectStatus,
                              "required"
                            )}
                          </div>
                        </Col>
                        <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            <Label className="form-label" htmlFor={"Session"}>
                              {"Reject Remarks"}{" "}
                              <span className="required">*</span>
                            </Label>
                          </div>
                          <Input
                            type="textarea"
                            placeholder="Enter Reject Remarks"
                            name="remarks"
                            value={rejectData.remarks}
                            onChange={(e) => handleRejectChange(e)}
                          />
                          <div style={{ textTransform: "capitalize" }}>
                            {rejectValidator.current.message(
                              "Reject Remarks",
                              rejectData.remarks,
                              "required"
                            )}
                          </div>
                        </Col>
                        <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            <Label className="form-label" htmlFor={"Session"}>
                              {"Attachment"} <span className="required">*</span>
                            </Label>
                          </div>
                          <Input
                            type="file"
                            name="rejectAttachment"
                            accept="application/pdf, audio/mp3 , image/png,image/jpeg"
                            // id="upload-btn"
                            multiple
                            onChange={(e) => rejectFileChange(e)}
                          />
                          <div style={{ textTransform: "capitalize" }}>
                            {rejectValidator.current.message(
                              "Attachment",
                              rejectAttachment,
                              "required"
                            )}
                          </div>
                        </Col>
                      </Modal.Body>
                      <Modal.Footer>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              handleRejectMessage()
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            No{" "}
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              rejectSubmit()
                            }}
                            className="btn btn-success buttons"
                            style={{ marginLeft: "15px" }}
                          >
                            {" "}
                            Yes{" "}
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {/* mobile attachment modal */}
                  {mobileAttachmentForm && (
                    <Modal
                      show={mobileAttachmentForm}
                      onHide={handleCloseAttachment}
                      size="lg"
                      style={{
                        backgroundColor: "#2a2a2bfa",
                        opacity: 1.5,
                      }}
                    >
                      <Modal.Header>
                        <h4>Mobile Attachment Details</h4>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className="event-label">Search</Label>
                            </div>
                            <Input
                              type="date"
                              name="mobileAttachment"
                              placeholder="Select Date"
                            />
                            <br />
                            <br />
                          </Col>

                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Date &#38; Time</th>
                                  <th>Customer Name</th>
                                  <th>Description</th>
                                  <th>Attachment</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {attachmentRecordUpdated &&
                                attachmentRecordUpdated.length > 0 ? (
                                  attachmentRecordUpdated.map((item) => {
                                    return (
                                      <>
                                        <tr key={item.key}>
                                          <td>{item.key + 1}</td>
                                          <td>{item.pickDateTime}</td>
                                          <td>{item.customerDetails}</td>
                                          <td>{item.description}</td>
                                          <td>
                                            {item.attachmentType == "image" ? (
                                              <object
                                                data={item.attachment}
                                                type="image/png"
                                                width="120"
                                                height="90"
                                              >
                                                <img
                                                  src={imageNotFound}
                                                  width="120"
                                                  height="90"
                                                />
                                              </object>
                                            ) : (
                                              ""
                                            )}

                                            {item.attachmentType == "audio" ? (
                                              <audio controls>
                                                <source
                                                  src={item.attachment}
                                                  type="audio/mpeg"
                                                />
                                                Your browser does not support
                                                the audio element.
                                              </audio>
                                            ) : (
                                              ""
                                            )}
                                            <br />
                                            <br />
                                            <a href={item.attachment} download>
                                              download
                                            </a>
                                          </td>
                                          <td>
                                            <div>
                                              <Input
                                                type="checkbox"
                                                className="form-check-input checkbox-attachment"
                                                name="checkbox"
                                                onChange={(e) =>
                                                  handleChangeAttachmentCheckbox(
                                                    e,
                                                    item.id,
                                                    item.attachment
                                                  )
                                                }
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={5}
                                      className="text-align-center"
                                    >
                                      {"No Data Found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={handleCloseAttachment}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={(event) => {
                            handleSubmitAttachment(event)
                          }}
                        >
                          Upload
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

ManageHighValueLead.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageHighValueLead)
)
